import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  content: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content
}: TestimonialCardProps) {
  return <div className="bg-white rounded-2xl p-6 md:p-8 relative border border-pastel-200 shadow-sm" data-id="element-277">
      <Quote className="absolute top-5 left-5 w-8 h-8 text-pastel-200" data-id="element-278" />
      <div className="relative z-10" data-id="element-279">
        <p className="text-gray-700 italic mb-6 text-base md:text-lg leading-relaxed" data-id="element-280">
          "{content}"
        </p>
        <div className="flex items-center gap-3" data-id="element-281">
          <div className="w-11 h-11 bg-pastel-100 rounded-full flex items-center justify-center text-pastel-700 font-bold text-lg" data-id="element-282">
            {name.charAt(0)}
          </div>
          <div data-id="element-283">
            <h4 className="font-bold text-gray-900" data-id="element-284">{name}</h4>
            <p className="text-sm text-gray-600" data-id="element-285">{role}</p>
            <p className="text-xs text-gray-400" data-id="element-286">{location}</p>
          </div>
        </div>
      </div>
    </div>;
}